import App from 'app/app.js';
import 'app/store/MessageStore.js';
import 'app/action/LoginSuccessAction.js';
import 'app/action/DeserializeAction.js';
import 'app/service/StorageService.js';
import 'app/service/BlockService.js';
import 'app/service/TranslateProviderService.js';
import 'app/action/ResetJobAction.js';
import 'app/action/JobLoadedAction.js';
import 'app/action/SessionTimeoutAction.js';

function RewardStore($http, $q) {
  var defaultTenPercentOff = {
    rewardId: '0',
    rewardProgramCode: '10PERCENTOFF_65',
    rewardThreshold: '65',
    currentPoint: '0.00',
    lastActivityDate: '0'
  };

  function buildRewards(response) {
    var rewards = { count: 0, active: [], redeemed: [], expired: [], inprogress: [] };
    var j;
    if (response && response.length >= 0) {
      for (j = 0; j < response.length; j++) {
        var reward = {
          rewardId: '',
          rewardProgramCode: '',
          rewardProgramCodeTitle: '',
          rewardThreshold: '',
          currentPoint: '',
          couponCode: '',
          expiryUser: '',
          expirySystem: '',
          status: '',
          lastActivityDate: ''
        };

        try {
          var rwd = response[j];
          if (rwd) {
            reward.rewardId = rwd.rewardId;
            reward.rewardProgramCode = rwd.rewardProgramCode;
            if (rwd.rewardThreshold.indexOf('.') > -1) {
              var x = rwd.rewardThreshold.split('.');
              reward.rewardThreshold = x[0];
            } else {
              //in the event they change this value to be an integer.
              reward.rewardThreshold = rwd.rewardThreshold;
            }
            reward.currentPoint = rwd.currentPoint;
            reward.lastActivityDate = rwd.lastActivityDate;
            if (rwd.rewardProgramCode === '10PERCENTOFF_65') {
              reward.rewardProgramCodeTitle = '10PERCENTOFF_65';
            }
            if (
              rwd.rewardProgramCode === 'FREEDIGIDOWNLOAD_SIGNUP' ||
              rwd.rewardProgramCode === 'FREEDIGIDOWNLOAD_3ORDERS'
            ) {
              reward.rewardProgramCodeTitle = 'FREE_HI_RES_REWARD_TITLE';
            }
            if (rwd.coupon) {
              reward.couponCode = rwd.coupon.couponCode;
              reward.expiryUser = rwd.coupon.expiryUser;
              reward.expirySystem = rwd.coupon.expirySystem;
              reward.status = rwd.coupon.status;
              if (reward.status === 'available' || reward.status === 'active') {
                // 2016.08.24 MarkN - put the free digital download at the beginning of the array
                //                    so it appears just below the instructions
                if (
                  rwd.rewardProgramCode === 'FREEDIGIDOWNLOAD_SIGNUP' ||
                  rwd.rewardProgramCode === 'FREEDIGIDOWNLOAD_3ORDERS'
                ) {
                  rewards.active.unshift(reward);
                } else {
                  rewards.active.push(reward);
                }
                reward = null;
              } else if (reward.status === 'redeemed') {
                reward.redemptionDate = rwd.coupon.redemptionDate;
                rewards.redeemed.push(reward);
                reward = null;
              } else if (reward.status === 'expired') {
                rewards.expired.push(reward);
                reward = null;
              }
            } else {
              rewards.inprogress.push(reward);
            }
            reward = null;
          }
        } catch (e) {
          //Retrieval of awards should not break the order flow.
        }
        rewards.count = response.length;
      }
      // 2016.08.15 MarkN - This allows display of the progress bar if the progress is zero and not returned from Rivit
      var inprogressRewards = R.find(R.propEq('rewardProgramCodeTitle', '10PERCENTOFF_65'))(rewards.inprogress);
      if (!inprogressRewards) {
        rewards.inprogress.push(defaultTenPercentOff);
      }
    }
    return rewards;
  }

  this.getRewards = function () {
    var deferred = $q.defer();
    $http.get('retrieveRewards').then(
      function (response) {
        if (response.data && response.data.success) {
          var rwds = buildRewards(response.data.data);
          deferred.resolve(rwds);
        } else {
          //resp = that.getRivitFailedMessage("USER_NOT_AUTHENTICATED");
          deferred.reject(response.data.reason);
        }
      }.bind(this),
      function (response) {
        if (response.data && response.data.error) {
          deferred.reject(response.data.error.code);
        } else {
          deferred.reject('UNABLE_TO_REACH_RIVIT');
        }
      }
    );
    return deferred.promise;
  };

  this.load = function () {
    var array = [];
    var testProgress = {
      rewardId: '0',
      rewardProgramCode: '10PERCENTOFF_65',
      rewardThreshold: 65.0,
      currentPoint: 0.0,
      lastActivityDate: '0'
    };
    array.push(testProgress);

    var testProgress1 = {
      rewardId: '0',
      rewardProgramCode: 'FREEDIGIDOWNLOAD_3ORDERS',
      rewardThreshold: 3,
      currentPoint: 0,
      lastActivityDate: '0'
    };
    array.push(testProgress1);
  };
}

App.service('RewardStore', ['$http', '$q', RewardStore]);

App.run([
  'RewardStore',
  function (RewardStore) {
    // eagerly initialize the store so that event listeners are registered
  }
]);
